import {DetectorType} from '../constants';

class AbstractStrategy {
  constructor(config)  {
    this.type     = DetectorType.FILE;
    this.config   = config;
    this.promises = [];
  }
}

export default AbstractStrategy;



// WEBPACK FOOTER //
// ./src/strategies/abstract.js